import { Reveal, RevealText } from "./Reveal";
import { useState } from "react";

const SERVICES = [
  {
    id: "01",
    title: "IA Agéntica",
    tagline: "Autonomous workflows · Multi-agent · Tool-use",
    description:
      "Métricas de rendimiento cuantificables. No tratamos con hipótesis; diseñamos resultados concretos. Arquitecturas multi-agente que razonan, planifican y ejecutan con autonomía supervisada.",
    bullets: [
      "Agentes autónomos de dominio",
      "Orquestación multi-agente",
      "Integraciones con sistemas core (SAP · Salesforce · ERPs)",
      "Human-in-the-loop y telemetría completa",
    ],
    image:
      "https://static.prod-images.emergentagent.com/jobs/0b83497b-e9f1-4fda-b8ac-9d11cf05e23a/images/638314a8df172bfb19f9dbc62a6d906fc27de4aefb6afa9b0de46bb137ca0185.png",
    span: "md:col-span-12",
    featured: true,
  },
  {
    id: "02",
    title: "Modelos Propios",
    tagline: "Vanguardia ·  Fine-tuning  ·  RLHF",
    description:
      "Desplegamos modelos de próxima generación antes de que se conviertan en el estándar de la industria. Entrenamiento especializado, fine-tuning de LLMs, y arquitecturas propietarias construidas para dominios críticos.",
    bullets: ["Foundation models privados", "Fine-tuning · RAG avanzado", "Evaluación y guardrails"],
    image:
      "https://static.prod-images.emergentagent.com/jobs/0b83497b-e9f1-4fda-b8ac-9d11cf05e23a/images/9b0322a672b1f5b7404b06528af4f5bb34daebc349a50377e8de2e8f658d738b.png",
    span: "md:col-span-8",
  },
  {
    id: "03",
    title: "Arquitectura de Datos",
    tagline: "Pipelines · Vector stores · Observabilidad",
    description:
      "ROI de alta densidad. Nuestros sistemas se integran a la perfección en los flujos de trabajo existentes para multiplicar el rendimiento de inmediato.",
    bullets: ["Data mesh enterprise", "Vector DB & embeddings", "MLOps · LLMOps"],
    image:
      "https://static.prod-images.emergentagent.com/jobs/0b83497b-e9f1-4fda-b8ac-9d11cf05e23a/images/5ff8a6eb665995e46433105034fac434a67031cf667a88a6fba76a1b57f2cbcc.png",
    span: "md:col-span-4",
  },
];

export const Services = () => {
  return (
    <section
      id="services"
      className="relative py-20 md:py-28 bg-[var(--bb-bg)] border-t border-[var(--bb-border)]"
      data-testid="services-section"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <Reveal>
          <div className="flex items-baseline justify-between mb-10">
            <div className="mono-label">[ 04 / Matriz de Soluciones ]</div>
            <div className="hidden md:block mono-label text-[var(--bb-copper)]">
              03 · Pilares
            </div>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 mb-14 md:mb-20 items-end">
          <h2 className="md:col-span-7 font-display text-[11vw] md:text-[6.5vw] leading-[0.95] tracking-[-0.03em] text-[var(--bb-text)]">
            <RevealText text="Matriz de" />
            <br />
            <span className="font-serif-italic text-[var(--bb-copper-light)]">
              <RevealText text="Soluciones." delay={0.25} />
            </span>
          </h2>
          <Reveal delay={0.35} className="md:col-span-5">
            <p className="font-body text-[var(--bb-text-2)] text-base md:text-lg leading-relaxed max-w-xl">
              Nuestra metodología es intransigente. Rechazamos el exceso en
              favor de la precisión. Cada algoritmo desplegado está
              meticulosamente diseñado para ofrecer el máximo impacto con la
              mínima fricción.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
          {SERVICES.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.1} className={s.span}>
              <ServiceCard {...s} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

const ServiceCard = ({ id, title, tagline, description, bullets, image, featured }) => {
  const [mx, setMx] = useState("50%");
  const [my, setMy] = useState("50%");

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    setMx(`${((e.clientX - r.left) / r.width) * 100}%`);
    setMy(`${((e.clientY - r.top) / r.height) * 100}%`);
  };

  return (
    <div
      className="bb-card h-full flex flex-col gap-8"
      style={{ ["--mx"]: mx, ["--my"]: my }}
      onMouseMove={onMove}
      data-testid={`service-card-${id}`}
    >
      <div className="flex items-start justify-between gap-4">
        <div className="mono-label text-[var(--bb-copper)]">// {id}</div>
        <div className="mono-label">{tagline}</div>
      </div>

      <div className={`grid gap-8 ${featured ? "md:grid-cols-2 items-center" : ""}`}>
        <div className="flex flex-col gap-6">
          <h3 className="font-display text-3xl md:text-5xl leading-[1.02] tracking-[-0.02em] text-[var(--bb-text)]">
            {title}
          </h3>
          <p className="font-body text-[var(--bb-text-2)] text-base md:text-lg leading-relaxed max-w-xl">
            {description}
          </p>
          <ul className="flex flex-col gap-3 pt-2">
            {bullets.map((b, i) => (
              <li
                key={i}
                className="flex items-start gap-3 font-mono text-[12px] tracking-[0.1em] text-[var(--bb-text-2)]"
              >
                <span className="mt-[6px] w-2 h-2 border border-[var(--bb-copper)]" />
                <span>{b}</span>
              </li>
            ))}
          </ul>
          <a
            href="#contact"
            className="bb-link font-mono text-[11px] tracking-[0.24em] uppercase mt-2 w-fit"
          >
            Explorar <span>→</span>
          </a>
        </div>

        {featured && (
          <div className="relative aspect-video md:aspect-[4/3] overflow-hidden border border-[var(--bb-border)]">
            <div
              className="absolute inset-0 bg-center bg-cover bb-img-accent"
              style={{ backgroundImage: `url(${image})` }}
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-[var(--bb-bg)] via-transparent to-transparent" />
          </div>
        )}
      </div>

      {!featured && (
        <div className="relative h-32 md:h-40 -mx-8 -mb-10 mt-auto overflow-hidden border-t border-[var(--bb-border)]">
          <div
            className="absolute inset-0 bg-center bg-cover bb-img-accent"
            style={{ backgroundImage: `url(${image})` }}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[var(--bb-bg-2)] via-[var(--bb-bg-2)]/40 to-transparent" />
        </div>
      )}
    </div>
  );
};
